import React from 'react';
import "./FAQ.css";

const FAQ = () => {
  const faqs = [
    {
      question: "¿Es legal subarrendar mi propiedad?",
      answer: "Sí, el subarrendamiento es legal siempre que se cumplan las condiciones del contrato de alquiler original y se notifique al propietario principal si es necesario. Nosotros nos encargamos de toda la gestión legal."
    },
    {
      question: "¿Qué pasa si un inquilino rompe algo o causa daños?",
      answer: "Nosotros asumimos todos los riesgos. En caso de daños, nos ocupamos de las reparaciones y mantenemos tu propiedad en perfectas condiciones sin que tengas que intervenir."
    },
    {
      question: "¿Cuánto tiempo tarda en empezar a generar ingresos?",
      answer: "Una vez firmado el contrato, comenzamos inmediatamente con la adecuación y búsqueda de inquilinos. Normalmente, en 2-4 semanas ya tienes los primeros ingresos."
    },
    {
      question: "¿Hay comisiones o costes ocultos?",
      answer: "No cobramos comisiones de agencia. Solo una tarifa de gestión mensual que se deduce de los ingresos generados. Todo transparente y sin costes ocultos."
    }
  ];

  return (
    <div className='faq section-p' id="faq">
        <div className='container'>
            <div className='faq-content'>
                <div className='section-title'>
                    <h3 className='text-brown'>Preguntas <span className='text-dark'>Frecuentes</span></h3>
                    <p className='text'>Resolvemos tus dudas sobre nuestros servicios inmobiliarios.</p>
                </div>

                <div className='faq-list'>
                    {
                        faqs.map((faq, index) => {
                            return (
                                <div className='faq-item' key={index}>
                                    <h4 className='faq-question'>{faq.question}</h4>
                                    <p className='faq-answer'>{faq.answer}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    </div>
  )
}

export default FAQ